import { Observable } from 'rxjs';
import { ReduxAction } from './redux.interface';
import { JournalRecord } from './journal-record.interface';
import { JournalQueryResult, QueryRequestConfig } from './journal-factory.interface';
import { ColumnParams } from './column-params.interface';
import { ColumnDynamicProperties } from './column-dynamic-properties.interface';

export interface Journal {
  id: string;
  name: string;
  columns: ColumnParams[];
}

export interface JournalService {
  getJournalByCode(code: string): Observable<Journal>;
  fetchQuery(queryRequest: QueryRequestConfig): Observable<JournalQueryResult>;
}

export interface JournalAdapter {
  // код журнала
  journalCode: string;
  // преоразование данных в данны журнала
  recordTransformer: (dto: any) => any;
}

// Данные состояние журнала при работе
export interface JournalState {
  // код журнала (представления данных)
  journalCode: string | null;
  /** адантер журнала, нужен для получения и формирования практически всех данных по журналу */
  // journalAdapter: JournalAdapter | null;
  // записи журнала
  records: JournalRecord[];
  // конфигурации колонок журнала по умолчанию со статической информацией
  journalColumns: ColumnParams[];
  // колонки подготовленные
  displayingColumns: ColumnParams[];
  /** Динамические свойства колонок: сортировка, порядок, ширина */
  columnsProperties: ColumnDynamicProperties[];
  // значение строки поиска по журналу
  searchText: string;
  /** Флаг для принудительного обновления настроек журнала, если его выставить в true, движок загрузит данные журнала с
   * сервера и запишет в состояние свежие данные, а также сбросит флаг в false
   */
  isNeedToLoadJournalSettings: boolean;
  /** Флаг для принудительной перезагрузки записей, если его выставить в true, то журнал загрузит записи при первой же
   * возможности (см. флаг isReadToLoadRecords), а затем сбросит флаг в false
   */
  isNeedToLoadRecords: boolean;
  // Флаг, сигнализирующий, что состояние журнала подготовлено  к получению данных для журнала
  isReadyToLoadRecords: boolean;

  hasErrors: boolean;
  pageSize?: number;
  rowsLimit?: number;
}

export interface JournalStateStore<T extends JournalState = JournalState> {
  // подключение к наблюдению за состоянием журнала
  getState(): Observable<T>;

  /**
   * Обработать какое-то действие
   * @param action Действие, содержит строковый тип и опционально полезную нагрузку
   */
  dispatch(action: ReduxAction): void;

  /**
   * Добавить side effect в хранилище, хранилище должно подписаться на переданный поток и диспатчить все полученные действия
   * @param effect$ Поток с действиями, каждое полученное действие будет задиспатчено
   */
  addEffect(effect$: Observable<ReduxAction>): void;
}
